export const emptyResource = { data: null, error: null, loading: false } as const;

export const SLACK_CREATE_CONNECTION_EVENT_ID = 'slack_connection_creation_response';

export const SlackErrorCodes = {
	AUTH_CODE_MISSING: 'auth_code_missing',
	CONNECTION_ALREADY_EXIST: 'connection_already_exist',
	CONNECTION_CREATION_FAILED: 'connection_creation_failed',
	FETCH_TOKEN_FAILED: 'failed_to_fetch_token',
	FORBIDDEN_TENANT: 'forbidden_tenant',
	INVALID_STATE: 'invalid_state',
	LINK_EXPIRED: 'link_expired',
	STATE_DECRYPTION_FAILED: 'state_decryption_failed',
	WORKSPACE_MISSMATCH: 'workspace_mismatch',
} as const;

export const MstErrorCodes = {
	TENANT_CONFLICT: 'tenant_conflict',
	TENANT_MISMATCH: 'tenant_mismatch',
} as const;

export const JIRA_SUPPORT_LINK = 'https://support.atlassian.com/contact/';
export const SLACK_IMAGE_URL =
	'https://resources.opsgeni.us/resources/images/public/integration/logos/SlackApp.png';
export const MST_IMAGE_URL =
	'https://resources.opsgeni.us/resources/images/public/integration/logos/MSTeams.png';
export const SLACK_TEXT = 'Slack';
export const MST_TEXT = 'Microsoft Teams';

export const MSTEAMS_CREATE_CONNECTION_EVENT_ID = 'microsoft_create_connection_response';
export const ADMIN_CONSENT_REQUIRED_EVENT_ID = 'microsoft_admin_permission_response';
export const SLACK_APP_TYPE = 'jsm-it-service-desk';
export const MST_APP_TYPE = 'jsm-msteams-app';
export const MSTEAMS_USER_LEVEL_AUTH_EVENT_ID = 'microsoft_delegated_permission_response';
export const SLACK_USER_LEVEL_AUTH_EVENT_ID = 'slack_user_auth_response';
export const TRANSITION_HOME_BUTTON_SPOTLIGHT_NAME = 'eoc-changeboarding_transition_home_lozenge';
export const HELP_PANEL_SPOTLIGHT_NAME = 'help-spotlight';
export const UNLOCK_LINK = '/jira/settings/products/ops/unlock';
